import type { IContainer } from '../interface/container';

interface IContainerPrv extends IContainer {
    _map: Map<symbol, unknown>;
    _parents: IContainer[];
}

export function buildObjectContainer(parents: IContainer[] = []): IContainer {
    const container: IContainerPrv = {
        _map: new Map(),
        _parents: parents,
        exists(key: symbol) {
            const valueMap =
                this._map.get(key) ??
                this._parents.find(containerSearch => containerSearch.get(key))?.get(key);

            return Boolean(valueMap);
        },
        get<T>(this: IContainerPrv, key: symbol): T {
            const valueMap = (this._map.get(key) ??
                this._parents.find(containerSearch => containerSearch.get(key))?.get(key)) as
                | T
                | undefined;

            if (valueMap === undefined || valueMap === null) {
                const values = Array.from(this._map.keys()).map(entry => entry.toString());
                throw new Error(
                    `Failed to resolve symbol:${String(key)} in container:${values.toString()}:${
                        values.length
                    }`,
                );
            }

            return valueMap;
        },
        bind(this: IContainerPrv, key: symbol, value: unknown) {
            this._map.set(key, value);
        },
        importBindings(this: IContainerPrv, containerImport: IContainer) {
            this._parents.unshift(containerImport);
        },
        remove(this: IContainerPrv, key: symbol) {
            this._map.delete(key);
        },
    };

    return container as IContainer;
}
